<div class="d-flex align-items-center">
  <div class="d-inline-flex bg-light rounded-pill border">
    @for (item of items; track $index) {
      <button class="btn rounded-pill m-0 px-3 py-2" [routerLink]="item.routerLink"
              [ngClass]="appContext.getUrlPath() === item.routerLink ? 'active text-primary' : ''">
        <i class="fa fa-fw fa-light fa-xl" [ngClass]="item.icon"></i>
      </button>
    }
  </div>
</div>
